// extracted by mini-css-extract-plugin
export default {"auth-wrapper":"Auth_auth-wrapper__k5VBt","auth-box":"Auth_auth-box__hWsFp","auth-box-heading":"Auth_auth-box-heading__kBKOH"};